import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Omikuji from "../pages/omikuji/page";
import FlowerLanguage from "../pages/flower-language/page";
import Plants from "../pages/plants/page";
import PrefectureFlowers from "../pages/prefecture-flowers/page";
import FlowerShop from "../pages/flower-shop/page";
import CelebrationFlowers from "../pages/celebration-flowers/page";
import Knowledge from '../pages/knowledge/page';
import TodayFlower from '../pages/today-flower/page';
import Essay from '../pages/essay/page';
import BlogPost from '../pages/blog-post/page';
import WelcomeBlog from '../pages/blog/welcome/page';
import OmikujiConceptBlog from '../pages/blog/omikuji-concept/page';
import WinterCyclamenBlog from '../pages/blog/winter-cyclamen/page';
import BirthFlowerGuideBlog from '../pages/blog/birth-flower-guide/page';
import WinterPoinsettiaBlog from '../pages/blog/winter-poinsettia/page';
import WinterChristmasRoseBlog from '../pages/blog/winter-christmas-rose/page';
import AutumnKoyoBlog from '../pages/blog/autumn-koyo/page';
import PrivacyPolicy from '../pages/privacy-policy/page';
import Contact from '../pages/contact/page';
import About from '../pages/about/page';
import FlowerShopVisitBlog from '../pages/blog/flower-shop-visit/page';
import NaturalistVisitBlog from '../pages/blog/naturalist-visit/page';
import PlantCommunicationBlog from '../pages/blog/plant-communication/page';
import AirCommunicationBlog from '../pages/blog/air-communication/page';
import UndergroundNetworkBlog from '../pages/blog/underground-network/page';
import InternalCommunicationBlog from '../pages/blog/internal-communication/page';
import InsectRecognitionBlog from '../pages/blog/insect-recognition/page';
import CallingPredatorsBlog from '../pages/blog/calling-predators/page';
import { lazy } from "react";

const InternalCommunicationPage = lazy(() => import('../pages/blog/internal-communication/page'));
const CallingPredatorsPage = lazy(() => import('../pages/blog/calling-predators/page'));
const StressMemoryPage = lazy(() => import('../pages/blog/stress-memory/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/flower-language',
    element: <FlowerLanguage />
  },
  {
    path: '/plants',
    element: <Plants />
  },
  {
    path: '/prefecture-flowers',
    element: <PrefectureFlowers />
  },
  {
    path: '/celebration-flowers',
    element: <CelebrationFlowers />
  },
  {
    path: '/flower-shop',
    element: <FlowerShop />
  },
  {
    path: '/omikuji',
    element: <Omikuji />
  },
  {
    path: '/knowledge',
    element: <Knowledge />
  },
  {
    path: '/today-flower',
    element: <TodayFlower />
  },
  {
    path: '/essay',
    element: <Essay />
  },
  {
    path: '/blog-post',
    element: <BlogPost />
  },
  {
    path: '/blog/welcome',
    element: <WelcomeBlog />
  },
  {
    path: '/blog/omikuji-concept',
    element: <OmikujiConceptBlog />
  },
  {
    path: '/blog/winter-cyclamen',
    element: <WinterCyclamenBlog />
  },
  {
    path: '/blog/birth-flower-guide',
    element: <BirthFlowerGuideBlog />
  },
  {
    path: '/blog/winter-poinsettia',
    element: <WinterPoinsettiaBlog />
  },
  {
    path: '/blog/winter-christmas-rose',
    element: <WinterChristmasRoseBlog />
  },
  {
    path: '/blog/autumn-koyo',
    element: <AutumnKoyoBlog />
  },
  {
    path: '/blog/flower-shop-visit',
    element: <FlowerShopVisitBlog />
  },
  {
    path: '/blog/naturalist-visit',
    element: <NaturalistVisitBlog />
  },
  {
    path: '/blog/plant-communication',
    element: <PlantCommunicationBlog />
  },
  {
    path: '/blog/air-communication',
    element: <AirCommunicationBlog />
  },
  {
    path: '/blog/underground-network',
    element: <UndergroundNetworkBlog />
  },
  {
    path: '/blog/internal-communication',
    element: <InternalCommunicationBlog />
  },
  {
    path: '/blog/insect-recognition',
    element: <InsectRecognitionBlog />
  },
  {
    path: '/blog/calling-predators',
    element: <CallingPredatorsPage />
  },
  {
    path: '/blog/stress-memory',
    element: <StressMemoryPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;